import { useToastNotification } from "@coworker/components/src/components/ToastNotification";
import { useTranslation } from "@coworker/locales";
import { useCreateTeam } from "../../hooks/useTeamMutations";
import TeamModal from "./TeamModal";
import { NewTeamDataType } from "../../types/TeamMutationTypes";

interface AddTeamModalProps {
  visible: boolean;
  close: () => void;
  storeId: string;
  hasActiveProductQualityTeam: boolean;
}

const AddTeamModal = ({
  visible,
  close,
  storeId,
  hasActiveProductQualityTeam,
}: AddTeamModalProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastNotification();
  const { mutate: createTeam, isPending: isSubmitting } =
    useCreateTeam(storeId);

  const handleSubmit = (newTeamData: NewTeamDataType) => {
    createTeam(newTeamData, {
      onSuccess: () => {
        showToast(
          t("teamSuccessfullyCreatedString", { teamName: newTeamData.name })
        );
        close();
      },
      onError: () => {
        showToast(
          t("failedCreatingTeamString", { teamName: newTeamData.name })
        );
      },
    });
  };

  return (
    <TeamModal
      key={visible ? "open" : undefined}
      visible={visible}
      close={close}
      storeId={storeId}
      hasActiveProductQualityTeam={hasActiveProductQualityTeam}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    />
  );
};

export default AddTeamModal;
